import React from 'react';

import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { blackText, blue, gray } from '../../constants/Colors';
import { titleMb } from '../../constants/Location';

const styles = {
  guideCard: {
    '@media screen and (max-width:600px)': {
      width: '80%'
    },
    width: '480px'
  },
  guideCloseButton: {
    color: blue
  },
  guideMark: {
    color: gray,
    cursor: 'pointer',
    heihgt: '18px',
    marginLeft: '4px',
    verticalAlign: 'middle',
    width: '18px'
  },
  guideText: {
    color: blackText,
    fontSize: '14px',
    whiteSpace: 'pre-wrap'
  },
  guideTitle: {
    color: blackText,
    fontSize: '22px',
    marginBottom: titleMb,
    padding: 0
  }
};

interface Props {
  title: string;
  guideText: string;
  color?: string;
}

const CustomGuideButton = React.forwardRef(
  (props: Props): React.ReactElement => {
    const { t } = useTranslation();
    const { title, guideText, color } = props;

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = (): void => {
      setOpen(true);
    };

    const handleClose = (): void => {
      setOpen(false);
    };

    return (
      <>
        <HelpOutlineOutlinedIcon
          sx={[styles.guideMark, ...(color ? [{ color }] : [])]}
          onClick={(e) => {
            e.stopPropagation();
            handleClickOpen();
          }}
        />
        <Dialog open={open} onClose={handleClose}>
          <DialogContent sx={styles.guideCard}>
            <DialogTitle sx={styles.guideTitle}>
              {title}
              {t('form.guideTitle')}
            </DialogTitle>
            <DialogContentText sx={styles.guideText}>
              {guideText}
            </DialogContentText>
            <DialogActions>
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  handleClose();
                }}
                sx={styles.guideCloseButton}
              >
                {t('form.guideClose')}
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
      </>
    );
  }
);
CustomGuideButton.displayName = 'CustomGuideButton';
export default CustomGuideButton;
